import { TextWrapper } from './wrappers';
import { Molecule } from 'AppReact';
import { Sort } from './atoms';
import { SecondaryTextSm400 } from 'atoms';
import { SortArrowsSvg } from 'components/icons';

export default Molecule({
  template: TextWrapper,
  type: 'button',
  atoms: [
    {
      component: SecondaryTextSm400,
      name: 'Label',
      displayValue: ({ content }) => content.label,
      displayState: ({ content, minWidth }) => ({ minWidth, whiteSpace: content.wrapHeader ? 'pre-wrap' : '' })
    },
    {
      component: Sort,
      name: 'SortArrows',
      renderIf: ({ content }) => !!content?.sortingField,
      displayValue: ({ sortOrder }) => SortArrowsSvg({ sortOrder }),
    },
  ]
})